import { render, staticRenderFns } from "./GalleryPopup.vue?vue&type=template&id=93c89ac8&scoped=true"
import script from "./GalleryPopup.vue?vue&type=script&lang=js"
export * from "./GalleryPopup.vue?vue&type=script&lang=js"
import style0 from "./GalleryPopup.vue?vue&type=style&index=0&id=93c89ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c89ac8",
  null
  
)

export default component.exports